import {MyopMessages} from "../../common/MyopMessages";
import {SetInnerHtml} from "../../messages";
import {ShadowRootRef} from "../shadowRootRef";
import {BaseWebComponentMessageHandler} from "./BaseWebComponentMessageHandler";
import {MyopElementMessage} from "../../messages";
import {getElementsByRef} from "../../common/messageHandlers/helpers";

export class SetInnerHtmlHandler extends BaseWebComponentMessageHandler<SetInnerHtml> {

    messageType = MyopMessages.SetInnerHtml;

    innerExecutor = (event: MyopElementMessage, shadowRootRef: ShadowRootRef) => {
        const items = getElementsByRef(event.ref, shadowRootRef.shadowRoot);
        items.forEach(item => {
            item.innerHTML = event.content;
        })
    }
}
